/* tslint:disable */
/* eslint-disable */
/**
 * Customer Journey Endpoints
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface ApprovalRequest
 */
export interface ApprovalRequest {
	/**
	 *
	 * @type {string}
	 * @memberof ApprovalRequest
	 */
	caseId?: string;
	/**
	 *
	 * @type {string}
	 * @memberof ApprovalRequest
	 */
	bankAccountOwnerName?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof ApprovalRequest
	 */
	bankAccountNumber?: string | null;
}

/**
 * Check if a given object implements the ApprovalRequest interface.
 */
export function instanceOfApprovalRequest(value: object): value is ApprovalRequest {
	return true;
}

export function ApprovalRequestFromJSON(json: any): ApprovalRequest {
	return ApprovalRequestFromJSONTyped(json, false);
}

export function ApprovalRequestFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): ApprovalRequest {
	if (json == null) {
		return json;
	}
	return {
		caseId: json['caseId'] == null ? undefined : json['caseId'],
		bankAccountOwnerName:
			json['bankAccountOwnerName'] == null ? undefined : json['bankAccountOwnerName'],
		bankAccountNumber: json['bankAccountNumber'] == null ? undefined : json['bankAccountNumber'],
	};
}

export function ApprovalRequestToJSON(json: any): ApprovalRequest {
	return ApprovalRequestToJSONTyped(json, false);
}

export function ApprovalRequestToJSONTyped(
	value?: ApprovalRequest | null,
	ignoreDiscriminator: boolean = false
): any {
	if (value == null) {
		return value;
	}

	return {
		caseId: value['caseId'],
		bankAccountOwnerName: value['bankAccountOwnerName'],
		bankAccountNumber: value['bankAccountNumber'],
	};
}
